const firebaseConfig = {
  apiKey: "AIzaSyAvnAh55N6rH5riRpMEexMt4z_uuySL4Cs",
  authDomain: "ghurifiri-1d2bb.firebaseapp.com",
  projectId: "ghurifiri-1d2bb",
  storageBucket: "ghurifiri-1d2bb.appspot.com",
  messagingSenderId: "533060592060",
  appId: "1:533060592060:web:f5415575aa1b50b7a98bb9"
};

export default firebaseConfig;